import * as R from "ramda";
import {getCookieValue, saveCookie} from "common/src/cookies/CookiesHelper";

export function resolveConversation(records, MEDIA_URL, getBlockApi, variables, imagesFromBucket, logGifAB) {
  records.sort(function(a, b) {
    return new Date(b.date) - new Date(a.date);
  });
  return R.map(record => resolveRecord(record, getBlockApi(record.block), MEDIA_URL, variables, imagesFromBucket), records, logGifAB).filter(
    record => !!record.payload
  );
}

export function ConversationMessage(side, type, payload, tag, key, alternativeText, variables) {
  return {
    side: side,
    type: type,
    payload: replaceStringVariables(payload, variables),
    tag: tag,
    key: key,
    alternativeText : replaceStringVariables(alternativeText, variables)
  };
}

function resolveRecord(record, blockApi, MEDIA_URL, variables, imagesFromBucket, logGifAB) {
  let node = blockApi.getNode(record.id);
  let payload = resolvePayload(node, MEDIA_URL, blockApi.block.gifs, imagesFromBucket, logGifAB);
  if (node.type === "button") return ConversationMessage(
      "right",
      node.view.type,
      !!record.textInput ? record.textInput : payload,
      null,
      `${node.id}`,
      node.view.alternativeText, variables);
  else
    return ConversationMessage(
      "left",
      node.view.type,
      payload,
      node.tag,
      `${record.block}_${node.id}${node.pointer !== undefined ? "_" + node.pointer : ""}`,
      node.view.alternative,
      variables
    );
}

function resolvePayload(node, MEDIA_URL, medias, imagesFromBucket, logGifAB) {
  if ((node.view.type !== "gif" && node.view.type !== "button-gif")) return node.view.payload;
  else if (imagesFromBucket) {
    const hash = getHash(node.view.payload, logGifAB);
    let media = R.find(media => media.hash === hash, medias);
    if (!media) {
      console.log(`Media of node with view '${JSON.stringify(node.view)}' not found in block definition`);
      return ''
    }
    return `${MEDIA_URL}/${media.hash}.${media.extension}`;
  }
  else return node.view.payload;
}


const GIF_SEPARATOR = '@@@@';

const getHash = (hash, logGifAB) => {
  const chooseRandom = (split, cookie) => {
    const random = split[Math.floor(Math.random() * split.length)];
    if (logGifAB) logGifAB(random)
    saveCookie('gif-hash', JSON.stringify([...cookie, random]))
    return parseInt(random);
  }
  if (!hash) return '';
  else if (Number.isFinite(hash)) return hash;
  else if (hash.includes(GIF_SEPARATOR)) {
    const split = hash.split(GIF_SEPARATOR).filter(h => !!h).map(s => parseInt(s));
    const hashCookie = getCookieValue('gif-hash');
    if (!hashCookie){
      return chooseRandom(split, [])
    }
    else {
      for (let h of split) {
        if (hashCookie.includes(h)) return h;
      }
      return chooseRandom(split, hashCookie)
    }
  }
  return hash;
}

const LOOKS_TAGS= ['gradient-set','ahp','likert'];

export function resolveButtons(records, MEDIA_URL, actions, getBlockApi, variables, imagesFromBucket, logGifAB) {
  if (records.length === 0) return null;
  records.sort(function(a, b) {
    return new Date(b.date) - new Date(a.date);
  });
  const lastRecord = R.last(records);
  const blockApi = getBlockApi(lastRecord.block);
  const lastNode = blockApi.getNode(lastRecord.id);
  const looksTag = lastNode.tag.filter((t)=>LOOKS_TAGS.indexOf(t.code) >= 0);
  if (lastNode.type !== "button-box") return null;
  else
    return {
      buttons: resolveButtonsPayload(lastNode.buttons, MEDIA_URL, blockApi, imagesFromBucket, logGifAB),
      tag: looksTag.length>0? looksTag[0].code:null, 
      blockApi: blockApi,
      onClickButton: actions.clickButton,
      onClickImage: actions.clickImage,
      variables
    };
}


function resolveButtonsPayload(buttons, MEDIA_URL, blockApi, imagesFromBucket, logGifAB) {
  return buttons.map(button => {
    return {
      ...button,
      blockName: blockApi.blockName,
      view: {
        ...button.view,
        payload: resolvePayload(button, MEDIA_URL, blockApi.block.gifs, imagesFromBucket, logGifAB)
      }
    };
  });
}

const STRING_VARIABLE_MARKER = '#';
const STRING_VARIABLE_SPLITTER = '$$'

export const replaceStringVariables = (text, variables) => {
  if (!text || !variables || !text.includes(STRING_VARIABLE_MARKER)) return text;
  return text.split(STRING_VARIABLE_SPLITTER).reduce((cum, word) => {
    if (word.startsWith(STRING_VARIABLE_MARKER) && word.endsWith(STRING_VARIABLE_MARKER)) {
      const code = word.substring(1, word.length - 1);
      return `${cum}${variables[code]}`
    }
    return `${cum}${word}`;
  }, '')
}


export const getTagByCode = (tags, code) => {
  const find = tags.filter((l) => l.code === code);
  return find.length > 0 ? find[0] : null;
};
